
export const GET_DISABLED_DATES = "GET_DISABLED_DATES";
export const POST_DISABLED_DATE = "POST_DISABLED_DATE";
export const DELETE_DISABLED = "DELETE_DISABLED";
export const GET_AVAILABE_DATES_AND_VALIDATE = "GET_AVAILABE_DATES_AND_VALIDATE";
export const GET_VALIDATE_POSTALCODE = "GET_VALIDATE_POSTALCODE";